import { useCallback } from 'react';
import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { GlowFieldWrapper, GlowFieldWrapperProps, GlowTextField, GlowTextFieldProps } from '../../atoms';

type GlowInputProps = GlowTextFieldProps & Omit<GlowFieldWrapperProps, 'children'>;

export const GlowInput: Component<GlowInputProps> = ({
    defaultValue,
    fieldId,
    required,
    errorText,
    optionalText,
    helperText,
    label,
    className,
    maxLength,
    displayMaxLength,
    value,
    ...props
}) => {
    const renderInput = useCallback(() => {
        return (
            <GlowTextField
                {...props}
                className={clsx(
                    'flex-1 p-0.75 rounded-0.5 bg-background-form text-text-primary',
                    'rounded-0.5 focus:outline-bold outline',
                    errorText
                        ? 'outline-border-error outline-bold'
                        : 'outline-medium outline-border-primary focus:outline-border-selected',
                )}
                defaultValue={defaultValue}
                value={value}
                required={required}
                maxLength={maxLength}
            ></GlowTextField>
        );
    }, [defaultValue, value, errorText, maxLength, props, required]);

    return (
        <GlowFieldWrapper
            className={className}
            fieldId={fieldId}
            required={required}
            errorText={errorText}
            optionalText={optionalText}
            label={label}
            helperText={helperText}
            value={value}
            maxLength={maxLength}
            displayMaxLength={displayMaxLength}
        >
            {renderInput}
        </GlowFieldWrapper>
    );
};
